export default function DepositVotingBar({ percent, className = '' }: { percent: string; className?: string }) {
  return (
    <div className={`w-full h-5 flex bg-dataviz_categorical_empty ${className}`}>
      <div className={`bg-gov_deposit`} style={{ width: `${percent}%` }}></div>
    </div>
  );
}
